export default __webpack_public_path__ + "static/media/unarchive_dropdown.86738c2c.png";